import React from 'react';
import Calender from './Calender'; // Import the Calender component

const CalenderPage = () => {
  return (
    <div className="calendar-page" style={{ backgroundColor: 'black' }}>
      <h1 className="text-center text-xl  font-bold"></h1>
      <Calender /> {/* Display the Calendar component */}
    </div>
  );
};

export default CalenderPage;
